<template>

  <vx-card :title="$t('class-over-view.assessment')" title-color="primary" class="mb-base">
    <li class="flex flex-inline justify-between w-full">
      <div class="flex-1">
        <vs-chip transparent color="primary">
          {{ $t('class-over-view.assessment-short') }}
        </vs-chip>
      </div>
      <div>
        <vs-chip class="pr-0" color="primary" transparent>
          <span>{{ $t('class-over-view.full-score') }}</span>
          <vs-chip class="bg-primary ml-2 mb-0 text-white font-semibold">{{ courseOutline.totalPoint}}
          </vs-chip>
        </vs-chip>
        <vs-chip transparent color="primary">
          {{ $t('exam-upload.header.score') }}
        </vs-chip>
      </div>
    </li>
    <li
      class="flex flex-inline justify-between items-center w-full px-3 pl-0"
      v-for="assessment in courseOutlineAssessments" :key="assessment.id"
    >
      <div class="flex-1 flex justify-start items-start">
        <vs-avatar class="bg-primary w-5 h-5 text-sm mr-2 p-2" :text="`${assessment.seq}`"/>
        <span class="text-sm mt-1">
                {{ assessment.assessment.nameLocal }}
              </span>
      </div>
      <div class="flex w-30 justify-between">
              <span class="w-16 text-right">
                {{ assessment.percent }}%
              </span>
        <span class="w-16 text-right">
                {{ assessment.score }}
              </span>
      </div>
    </li>
  </vx-card>

</template>

<script>
    export default {
      props:{
        classRoom: Object
      },
      computed:{
        courseOutlineAssessments(){
          return this.classRoom ? this.classRoom.courseOutlineRegistration.courseOutline.courseOutlineAssessments : [];
        },
        courseOutline(){
          return this.classRoom ? this.classRoom.courseOutlineRegistration.courseOutline : {};
        },
      },
    }
</script>

<style scoped>

</style>
